import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import Home from '../components/home.component';
import Index from '../components/index'
import Mobile from '../components/mobileLandingPage.component';
import PrivacyPolicy from '../components/PrivacyPolicy';
import Terms from '../components/TermsAndConditions';
import Download from '../components/DownloadURL';
import EmailVerified from '../components/EmailVerified.component';
import myStores from '../stores';
import { Provider, Observer } from 'mobx-react';

const HomePage = () => (
  <Observer
    inject={stores => ({ myStores : stores.myStores })}
    render={props => (<Home {...props} />)}
  />
)

const Main = () => (
  <Provider myStores={myStores} >
    <Router>
      <Switch>
        <Route path='/' exact component={Index} />
        <Route path='/mobile' component={Mobile} />
        <Route path='/email-verified' component={EmailVerified} />
        <Route path='/login' component={HomePage} />
        <Route path='/download' component={Download} />
        <Route path='/terms' component={Terms} />
        <Route path='/privacy' component={PrivacyPolicy} />
      </Switch>
    </Router>
  </Provider>

)

export default Main;



// WEBPACK FOOTER //
// ./src/screens/main.screen.js